import * as React from 'react';

import { Alert } from '@components/common';

export const RepositoryDisabledAlert: React.FC<{ feature: string }> = ({ feature }) => (
  <Alert type='error' className='m-6' heading={`${feature} disabled`}>
    Your workspace admin has disabled the Repository feature.
  </Alert>
);
